var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a821wmmpa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.336 10h-.667a1.333 1.333 0 0 1-1.333-1.334v-6a1.333 1.333 0 0 1 1.333-1.333h6a1.333 1.333 0 0 1 1.334 1.333v.667M7.336 6h6c.736 0 1.333.597 1.333 1.333v6c0 .736-.597 1.333-1.333 1.333h-6a1.333 1.333 0 0 1-1.333-1.333v-6C6.003 6.597 6.6 6 7.336 6z",
    stroke: "#545454",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a821wmmpa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHover);
export default __webpack_public_path__ + "static/media/copy_hover.f328b02cc22bd76d512d3471758ce86e.svg";
export { ForwardRef as ReactComponent };